export default __webpack_public_path__ + "static/media/SJ-Main Blank Fillable Boarding Slip.006614a8.pdf";